import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_PURPLE,
    textAlign: 'center',
    fontSize: 18,
  },
  textInformation: {
    lineHeight: 1.4,
    fontSize: 15,
  },
}));
